import { createPortal } from 'react-dom';
import { Toaster } from 'react-hot-toast';

export const ToastContainer = () => {
  const node = document.getElementById('toasts');

  return <>{createPortal(<Toaster containerStyle={{ top: 100 }} />, node || document.body)}</>;
};
